// Customizable Area Start
import React, { Component } from "react";
import { Box, styled, Typography } from "@mui/material";
import CustomAvatar from "./CustomAvatar.web";
import { formatChatTime, getLastMessagePreview } from "./utils";
import { Conversation } from "../../blocks/chat/src/ChatController";

const ChatSummaryWrapper = styled(Box)({
  borderBottom: "1px solid #CBD5E1",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "14px",
  overflow: "hidden",
  width: "100%",
  boxSizing: "border-box",
  cursor: "pointer",
  "&.active_chat": {
    backgroundColor: "#F1F5F9",
  },
});

const UserName = styled(Typography)({
  color: "#0F172A",
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "19.36px",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
  minWidth: 0,
});

const MessagePreview = styled(Typography)({
  color: "#475569",
  fontSize: "0.875rem",
  fontWeight: 300,
  lineHeight: "19.69px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0,
});

const TimeCountWrapper = styled(Box)({
  display: "flex",
  gap: "3px",
  flexDirection: "column",
  alignItems: "center",
});

const MessageTime = styled(Typography)({
  color: "#64748B",
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const UnreadCount = styled(Typography)({
  backgroundColor: "#652784",
  height: "20px",
  width: "20px",
  borderRadius: "50%",
  fontSize: "0.75rem",
  fontWeight: 500,
  textAlign: "center",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

interface Props {
  isActiveChat: boolean;
  chatInfo: Conversation;
  toggleSelection: (chatId: string) => void;
}

export class ChatSummaryCard extends Component<Props> {
  render() {
    const { chatInfo, isActiveChat, toggleSelection } = this.props;
    const {
      lastMessage,
      conversationWith,
      unreadMessageCount,
    } = chatInfo;
    const { avatar, name, status } = conversationWith;
    const isOnline = status === "online";

    return (
      <ChatSummaryWrapper
        className={isActiveChat ? "active_chat" : ""}
        onClick={() => toggleSelection(conversationWith.uid)}
      >
        <CustomAvatar
          isShowStatus
          width={44}
          height={44}
          name={name}
          url={avatar || ""}
          isOnline={isOnline}
        />
        <Box
          flex={1}
          minWidth={0}
          display="flex"
          overflow="hidden"
          flexDirection="column"
        >
          <UserName>{name}</UserName>
          <MessagePreview data-test-id="con-last-message">
            {lastMessage && getLastMessagePreview(lastMessage)}
          </MessagePreview>
        </Box>
        <TimeCountWrapper>
          <MessageTime>
            {lastMessage && formatChatTime(lastMessage.sentAt)}
          </MessageTime>
          {unreadMessageCount > 0 && (
            <UnreadCount data-test-id="unread-count">
              {unreadMessageCount}
            </UnreadCount>
          )}
        </TimeCountWrapper>
      </ChatSummaryWrapper>
    );
  }
}

export default ChatSummaryCard;
// Customizable Area End
